import React from "react";
import { Plus, Send, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { UnpublishedChangesMenu } from "@/components/calendar/UnpublishedChangesMenu";

export const CalendarCommandBar = ({
  eventCount,
  projectCount,
  isManager,
  unpublishedSchedules,
  selectedIds,
  deleting,
  onNewProject,
  onNewSchedule,
  onPublish,
  onDeleteSelected,
  onSelectionChange,
}) => (
  <div className="flex min-h-9 flex-wrap items-center gap-2 md:flex-nowrap" data-testid="calendar-command-bar">
    <div className="flex shrink-0 items-baseline gap-2">
      <h1 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="calendar-page-title">
        Schedule
      </h1>
      <span className="hidden text-xs text-slate-500 sm:inline" data-testid="calendar-counts">
        {eventCount} events · {projectCount} projects
      </span>
    </div>

    {isManager && (
      <div className="ml-auto flex w-full flex-wrap items-center justify-end gap-1.5 pb-0.5 md:w-auto md:flex-nowrap" data-testid="calendar-primary-actions">
        <Button variant="outline" size="sm" className="h-8 shrink-0 px-2.5 text-xs" onClick={onNewProject} data-testid="new-project-btn">
          <Plus className="mr-1 h-3.5 w-3.5" /> Project
        </Button>
        <Button size="sm" className="h-8 shrink-0 px-2.5 text-xs" onClick={onNewSchedule} data-testid="new-schedule-btn">
          <Plus className="mr-1 h-3.5 w-3.5" /> Schedule
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 shrink-0 px-2.5 text-xs text-red-600 hover:bg-red-50 hover:text-red-700"
          onClick={onDeleteSelected}
          disabled={!selectedIds.length || deleting}
          data-testid="delete-selected-drafts-button"
        >
          <Trash2 className="mr-1 h-3.5 w-3.5" />
          {deleting ? "Deleting…" : `Delete Selected${selectedIds.length ? ` (${selectedIds.length})` : ""}`}
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 shrink-0 px-2.5 text-xs"
          onClick={onPublish}
          disabled={!selectedIds.length}
          data-testid="publish-schedules-btn"
        >
          <Send className="mr-1 h-3.5 w-3.5" /> Publish{selectedIds.length ? ` (${selectedIds.length})` : ""}
        </Button>
        <UnpublishedChangesMenu
          schedules={unpublishedSchedules}
          selectedIds={selectedIds}
          onSelectionChange={onSelectionChange}
        />
      </div>
    )}
  </div>
);